import React from 'react'

import styled from 'styled-components/native'

import { lightThemeColors } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/colors'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Display } from '../../atoms/display/Display'
import { BodyTextSize, DisplaySize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

const Container = styled.View(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing['16px'],
}))

const DetailContainer = styled.View(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing['8px'],
}))

const Row = styled.View<{ theme: ThemeType; withBreakpoints?: boolean }>(({ theme: { spacing }, withBreakpoints }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: withBreakpoints ? spacing['16px'] : undefined,
}))

const LabelColumn = styled.View<{ theme: ThemeType; withBreakpoints?: boolean }>(
  ({ theme: { breakpoints }, withBreakpoints }) => ({
    flex: withBreakpoints ? (breakpoints.isMinWidthLaptop ? 0.4 : 0.3) : undefined,
    width: withBreakpoints ? undefined : '112px',
    alignItems: 'flex-start',
    justifyContent: 'center',
    lineHeight: withBreakpoints ? undefined : '24px',
  }),
)

const ValueColumn = styled.View<{ theme: ThemeType; withBreakpoints?: boolean }>(
  ({ theme: { breakpoints, spacing }, withBreakpoints }) => ({
    flex: withBreakpoints ? (breakpoints.isMinWidthLaptop ? 0.6 : 0.7) : 1,
    flexShrink: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    gap: spacing['8px'],
  }),
)

export type ClientDetailsSideBarSectionItem = {
  key: string
  label: React.ReactNode
  value?: React.ReactNode
  textValue?: React.ReactNode
  testID?: string
  suffix?: React.ReactNode
}
export type ClientDetailsSideBarSectionProps = {
  items: ClientDetailsSideBarSectionItem[]
  headerText?: React.ReactNode
  withBreakpoints?: boolean
  valueTextSize?: BodyTextSize
}

export const ClientDetailsSideBarSection: React.FC<ClientDetailsSideBarSectionProps> = ({
  headerText,
  items,
  withBreakpoints = false,
  valueTextSize = BodyTextSize.DEFAULT,
}) => {
  return (
    <Container>
      {headerText && <Display size={DisplaySize.EYEBROW} text={headerText} />}
      <DetailContainer>
        {items.map((item) => (
          <Row key={item.key} testID={item.testID} withBreakpoints={withBreakpoints}>
            <LabelColumn withBreakpoints={withBreakpoints} testID={tID(`${item.testID}-label`)}>
              <BodyText size={BodyTextSize.CAPTION} text={item.label} color={lightThemeColors.textSecondary} />
            </LabelColumn>
            <ValueColumn withBreakpoints={withBreakpoints} testID={tID(`${item.testID}-value`)}>
              {item.textValue ? (
                <BodyText text={item.textValue} size={valueTextSize} color={lightThemeColors.textPrimary} />
              ) : (
                item.value
              )}
              {item.suffix}
            </ValueColumn>
          </Row>
        ))}
      </DetailContainer>
    </Container>
  )
}
